import { StructuredTextDocument } from "datocms-structured-text-to-html-string";
import React from "react";
import ResponsiveContentWidthWrapper from "../ResponsiveContentWidthWrapper";
import SectionWrapper from "../SectionWrapper";
import StructuredTextGeneric from "../StructuredTextGeneric";

interface Props {
  lead: Queries.EventPageQuery["datoCmsEvent"]["lead"];
}

const EventPageSectionLead = ({ lead }: Props) => {
  const data = lead as unknown as StructuredTextDocument;
  return (
    <SectionWrapper noBorder additionalWrapperClassName="lg:mb-16">
      <ResponsiveContentWidthWrapper>
        <StructuredTextGeneric data={data} />
      </ResponsiveContentWidthWrapper>
    </SectionWrapper>
  );
};

export default EventPageSectionLead;
